enum TemplateType {
  EMAIL = 'Email',
  LINKEDIN = 'Linkedin',
  INVITATION = 'Invitation',
  SCRIPT = 'Script',
  IN_MAIL = 'InMail',
  VOICE_NOTE = 'VoiceNote',
}

export default TemplateType;
